module.exports = __webpack_public_path__ + "static/media/wrs2.png.641fb6d1.jpg";